module.exports = __webpack_public_path__ + "media/images/heart_empty-7c83be96eb216242379b1830e2c8e7c5.svg";